// 兼容性 hook：从 appStore 导出，保持与旧代码的兼容性
import { useAppStore } from '../stores';
import { defaultThemeConfig } from '../lib/theme';

export const useTheme = () => {
  const { themeConfig, updateThemeConfig, setThemeMode, resetThemeConfig } = useAppStore();
  
  // 确保 themeConfig 有值，避免未初始化的问题
  const safeThemeConfig = themeConfig || defaultThemeConfig;
  
  return {
    config: safeThemeConfig,
    updateConfig: updateThemeConfig,
    setMode: setThemeMode,
    resetConfig: resetThemeConfig,
  };
};
